import { observable } from "mobx";
import PayGatePaymentResponse from "./payGatePaymentResponse";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class KioskOrderDetailResponse {
  /**
   * Kiosk name.
   */
  @observable
  name!: string;

  /**
   * Kiosk identification
   */
  @observable
  kioskIdent!: number;

  @observable
  @Type(() => PayGatePaymentResponse)
  payGatePayment!: PayGatePaymentResponse;
}
